import script from "./SearchPageFilters.vue?vue&type=script&setup=true&lang=ts"
export * from "./SearchPageFilters.vue?vue&type=script&setup=true&lang=ts"

import "@/assets/css/search-page/search-page.css?vue&type=style&index=0&id=78a3e2b4&scoped=true&lang=css&external"
import "@/assets/css/search-page/search-page-filters.css?vue&type=style&index=1&id=78a3e2b4&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-78a3e2b4"]])

export default __exports__